module.exports = __webpack_public_path__ + "img/diners.43cbbcfd.svg";